import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Login from "../Component/Login";
import Logo from "../assets/kvl-png.png";

export default function HeaderNavbar({ isHome }) {
  const token = localStorage.getItem("user"); // or whatever key you use
  const isLoggedIn = !!token;
  const [showLogin, setShowLogin] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const openLoginModal = () => {
      console.log("Login event received");
      setShowLogin(true);
    };

    window.addEventListener("open-login-modal", openLoginModal);

    return () => {
      window.removeEventListener("open-login-modal", openLoginModal);
    };
  }, []);

  const navStyle = {
    width: isHome ? "90%" : "100%",
    background: isHome ? "rgba(255,255,255,0.75)" : "#fff",
    backdropFilter: isHome ? "blur(6px)" : "none",
    position: "sticky",
    top: 0,
    marginTop: isHome ? "15px" : "0",
    borderRadius: isHome ? "16px" : "0",
    boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
    zIndex: 1000,
  };

  const linkStyle = (path) => ({
    fontWeight: 600,
    color: location.pathname === path ? "#7b1e3b" : "#444",
    borderBottom:
      location.pathname === path
        ? "2px solid #7b1e3b"
        : "2px solid transparent",
    paddingBottom: "4px",
  });

  return (
    <>
      <Navbar
        expand="lg"
        className={`shadow-sm ${isHome ? "mx-auto rounded-4" : ""}`}
        style={navStyle}
      >
        <Container
          fluid className={!isHome ? "px-4 px-lg-5" : ""}

        >
          <Navbar.Brand
            as={Link}
            to="/"
            className="navbar-brand-custom d-flex align-items-center text-decoration-none"
          >
            <img
              src={Logo}
              alt="KVL Matrimony"
              style={{
                height: "clamp(35px, 5vw, 55px)",
                width: "auto",
              }}
            />

            <div className="ms-2">
              <h5
                className="mb-0"
                style={{
                  color: "#7b1e3b",
                  fontWeight: "700",
                  fontFamily: "Georgia, 'Times New Roman', serif",
                  letterSpacing: "1px",
                  lineHeight: "1.1",
                }}
              >
                KVL Matrimony
              </h5>

              <small
                style={{
                  color: "#777",
                  fontSize: "11px",
                  letterSpacing: "1px",
                }}
              >
                TRUSTED LINGAYAT MATRIMONY
              </small>
            </div>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="main-navbar" />

          <Navbar.Collapse
            id="main-navbar"
            className="justify-content-between text-center"
          >
            {/* Center Menu */}
            <Nav className="navbar-menu mx-auto">
              <Nav.Link as={Link} to="/" style={linkStyle("/")}>
                Home
              </Nav.Link>

              <Nav.Link as={Link} to="/about-us" style={linkStyle("/about")}>
                About Us
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/membership"
                style={linkStyle("/membership")}
              >
                Membership Plans
              </Nav.Link>

              <Nav.Link as={Link} to="/contact" style={linkStyle("/contact")}>
                Contact
              </Nav.Link>
            </Nav>

            {/* Right Side */}
            <div className="navbar-actions">
              {isLoggedIn ? (
                <>
                  <Button
                    className="px-3 rounded-3"
                    style={{
                      background: "#7b1e3b",
                      border: "none",
                    }}
                    onClick={() => navigate("/user/home")}
                  >
                    My Dashboard
                  </Button>
                </>
              ) : (
                <>
                  <span
                    className="fw-semibold"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowLogin(true)}
                  >
                    Login
                  </span>

                  <Button
                    className="px-3 rounded-3"
                    style={{
                      background: "#7b1e3b",
                      border: "none",
                    }}
                    onClick={() => navigate("/register")}
                  >
                    Register
                  </Button>
                </>
              )}
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Login Modal */}
      <Login show={showLogin} handleClose={() => setShowLogin(false)} />
    </>
  );
}
